module.exports = __webpack_public_path__ + "img/trashcan-icon.244c86c0.svg";